import {
  Activity,
  BadgeIndianRupee,
  BookUser,
  ClipboardCheck,
  HandCoins,
  House,
  Network,
  Plug,
  ReceiptIndianRupee,
  Signature,
  Tags,
  Bot,
  KeyRound,
  Sparkles,
  CircleHelp,
  Workflow,
  LayoutDashboard,
  Plus,
  ListTodo,
  ShoppingCart,
  Truck,
  CheckCircle,
  FlaskConical,
  CreditCard,
  Package,
  TruckIcon,
  Factory,
  Shield,
  BadgeCheck,
  Gauge,
  UserCog,
  Building2,
  Menu,
  Globe,
  ChevronDown,
  Bell,
  BellRing,
  LayoutList,
  LayoutGrid,
  Inbox,
  ArrowLeft,
  ArrowRight,
  Filter,
  MoreVertical,
  Eye,
  Pencil,
  Trash2,
  Route,
  Gavel,
  FileText,
  RefreshCw,
  UserPlus,
  X as Close,
  LayoutTemplateIcon,
  Glasses,
  Tag,
  Calendar,
  Phone,
  Clock,
  Settings,
  Hash,
  Info,
  Wrench,
  ClipboardList,
  Box,
  User,
  ArrowLeftCircleIcon,
  ArrowRightCircleIcon,
  UploadIcon,
  FileIcon,
  DownloadIcon,
  ZoomInIcon,
  ZoomOutIcon,
  Rotate3DIcon,
  FullscreenIcon,
  MinimizeIcon,
  SearchIcon,
  LifeBuoy,
  Warehouse,
  CheckCircle2Icon,
  BoxIcon,
  ScanIcon,
  Check,
  Play,
  FastForward,
  TowerControlIcon,
  MapIcon,
  ArrowLeftRight,
  CirclePlus,
  CircleMinus,
  CircleArrowRight,
  CircleArrowLeft,
  ArrowUpNarrowWide,
  ArrowDownNarrowWide,
  TriangleAlert,
  PackageCheck,
  Building,
  Handshake,
  File,
  FileStack,
  FilePlus,
  FolderPlus,
  Files,
  Archive,
  FolderArchive,
  ListPlus,
  ListChecks,
  IdCard,
  Library,
  NotebookText,
  ScrollText,
  FilePlus2,
  LayoutTemplate,
  BookPlus,
  BookCopy,
  BarChart3,
  FileSignature,
  FolderKanban,
  FileCheck,
  Shapes,
  Landmark,
  Mail,
  Copy,
  ExternalLink,
  NotepadText,
  LayoutPanelTop,
} from "lucide-react";
import { FaFacebook } from "react-icons/fa6";
import { FaLinkedin } from "react-icons/fa6";
import { FaSkype } from "react-icons/fa6";
import { FaTwitter } from "react-icons/fa6";

export const NAV_ICONS = {
  add: Plus,
  home: House,
  dashboard: LayoutDashboard,
  analytics: BarChart3,
  tasks: ListTodo,
  orders: ShoppingCart,
  logistics: Truck,
  approvals: CheckCircle,
  qc: FlaskConical,
  billing: CreditCard,
  inventory: Package,
  fleet: TruckIcon,
  production: Factory,
  // Parties: the people and companies contracts are made with.
  customers: BookUser,
  staffs: IdCard,

  admin: Shield,
  roles: UserCog,
  organisation: Building2,

  menu: Menu,
  globe: Globe,
  chevron: ChevronDown,
  notification: Bell,
  renewalReminder: BellRing,
  copyLink: Copy,
  openInNewTab: ExternalLink,
  list: LayoutList,
  grid: LayoutGrid,
  inbox: Inbox,
  collapse: ArrowLeft,
  expand: ArrowRight,
  filter: Filter,
  more: MoreVertical,
  view: Eye,
  edit: Pencil,
  delete: Trash2,
  dispatcher: Route,
  rules: Gavel,
  msa: FileText,
  refresh: RefreshCw,
  ai: Sparkles,
  aiKeys: KeyRound,
  applicationStatus: Activity,
  aiAgents: Bot,
  close: Close,
  userPlus: UserPlus,
  table: LayoutTemplateIcon,
  quickView: Glasses,

  tag: Tag,
  calendar: Calendar,
  phone: Phone,
  clock: Clock,
  settings: Settings,
  workflow: Workflow,
  id: Hash,
  info: Info,
  maintenance: Wrench,
  audit: ClipboardList,
  box: Box,
  user: User,
  email: Mail,
  navLeft: ArrowLeftCircleIcon,
  navRight: ArrowRightCircleIcon,
  upload: UploadIcon,
  filePdf: FileIcon,
  download: DownloadIcon,
  zoomIn: ZoomInIcon,
  zoomOut: ZoomOutIcon,
  rotate: Rotate3DIcon,
  fullScreen: FullscreenIcon,
  minimize: MinimizeIcon,
  search: SearchIcon,
  product: LifeBuoy,
  warehouse: Warehouse,
  tick: CheckCircle2Icon,
  arrived: BoxIcon,
  delivering: ScanIcon,
  check: Check,
  play: Play,
  statusForward: FastForward,
  controlCentre: TowerControlIcon,
  map: MapIcon,
  publish: CircleArrowRight,
  revert: CircleArrowLeft,
  activate: CirclePlus,
  deactivate: CircleMinus,

  facebook: FaFacebook,
  linkedIn: FaLinkedin,
  skype: FaSkype,
  twitter: FaTwitter,

  increase: ArrowUpNarrowWide,
  decrease: ArrowDownNarrowWide,
  high: TriangleAlert,
  pickupRelease: PackageCheck,

  businessUnit: Building,
  department: Network,
  switch: ArrowLeftRight,

  contracts: Handshake,
  obligations: ClipboardCheck,
  receivables: HandCoins,

  file: File,
  allContracts: FileStack,
  newContract: FilePlus,
  createContract: FolderPlus,
  bulkContracts: Files,
  legacyContract: Archive,
  bulkLegacyContracts: FolderArchive,

  createObligations: ListPlus,
  allObligations: ListChecks,

  createReceivables: BadgeIndianRupee,
  allReceivables: ReceiptIndianRupee,

  library: Library,
  contractTemplates: NotebookText,
  clauseTemplates: ScrollText,
  addContractTemplate: FilePlus2,
  allContractTemplates: LayoutTemplate,
  addClauseTemplate: BookPlus,
  allClauseTemplates: BookCopy,

  conractTitle: FileSignature,
  contractCategories: FolderKanban,
  contractType: FileCheck,
  clauseType: Shapes,
  jurisdiction: Landmark,
  entityType: Tags,

  eSignature: Signature,
  providers: Plug,
  licensing: BadgeCheck,
  help: CircleHelp,
  subscription: Gauge,

  emailTemplate: Mail,
  noticeTemplate: NotepadText,
  receivableTemplates: LayoutPanelTop,
};
